// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"04600e68","519":"21153496","826":"48357334"}[chunkId] + ".chunk.js";
};